import { render, staticRenderFns } from "./MyKPIsGauges.vue?vue&type=template&id=141cc1ff&"
import script from "./MyKPIsGauges.vue?vue&type=script&lang=js&"
export * from "./MyKPIsGauges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports